import React, { useEffect, useState } from 'react'
import { CircularProgress, Backdrop, Box, Grid, TextField, Autocomplete, ListItemText, MenuItem, Button } from '@mui/material'
import axios from 'axios'
import { LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { Api } from '../../../components/api';
import { fDateTo } from '../../../utils/formatTime';

export default function EventLog({ account, userId, permissions }) {
    const selectedTime = new Date();
    const [loading, setloading] = useState(true)
    const [varDevice, setVarDevice] = useState("")
    const [master_event_iframe, set_master_event_iframe] = useState([])
    const [fieldValueDevice, setFieldValueDevice] = useState(null)
    const [fieldValueStart, setFieldValueStart] = useState(fDateTo(selectedTime.setHours(0, 0, 0), 'yyyy-MM-dd HH:mm'))
    const [fieldValueEnd, setFieldValueEnd] = useState(fDateTo(selectedTime.setHours(23, 59, 59), 'yyyy-MM-dd HH:mm'))
    const [devices, setDevices] = useState([])
    const [isSubmit, setIsSubmit] = useState(false)

    const [type, setType] = useState({ name: "", url: "" })
    const [fieldDynamicValue, setfieldDynamicValue] = useState(null)
    const [fieldDynamicSpeed, setfieldDynamicSpeed] = useState('')

    const [key, setKey] = useState(0);

    const handleReload = () => {
        setKey(prevKey => prevKey + 1);
    };





    useEffect(() => {
        Api.get(`/Tracking/DevicesSearch?userid=${userId}&search=*`).then((res) => {
            const updatedData = res.data.map((item) => ({
                ...item,
                vehicle_id: item.vehicle_id ? item.vehicle_id : item.device,
            }));
            var devices_ = updatedData.sort((a, b) => a.vehicle_id?.localeCompare(b.vehicle_id));
            setDevices(devices_)
            setloading(false)
        }
        ).catch(e => {
            console.log('error', e)
        })
    }, [userId])


    useEffect(() => {
        axios.get(`https://api02.sitgps.com/gps_master_event_iframe`)
            .then((res) => {
                set_master_event_iframe(res.data)

            })
            .catch(err => {
                console.log('err', err)
            })
    }, [])

    const onSubmit = (event) => {
        // setIsSubmit(false)
        handleReload()
        event.preventDefault();
        setIsSubmit(true)
    }


    return (
        <div style={{ padding: "10px" }}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Backdrop
                    sx={{ color: "whitesmoke", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={loading}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <form onSubmit={onSubmit} >
                    <Box>
                        <Grid container spacing={1}>
                            <Grid item md={3}>
                                <TextField
                                    label="ประเภทรายงาน"
                                    fullWidth
                                    autoComplete="off"
                                    name="ifame"
                                    size="small"
                                    select
                                    value={type.name}
                                >
                                    {
                                        master_event_iframe.map((iframe, i) => {
                                            return (
                                                <MenuItem
                                                    onClick={() => {
                                                        setType(iframe)
                                                        setIsSubmit(false)
                                                        if (iframe.dynamic_value) {
                                                            setfieldDynamicValue(JSON.parse(iframe.dynamic_value))
                                                            setfieldDynamicSpeed("")
                                                        } else {
                                                            setfieldDynamicValue(null)
                                                            setfieldDynamicSpeed("")
                                                        }
                                                    }}
                                                    value={iframe.name}>
                                                    {iframe.name}
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </TextField>
                            </Grid>
                            <Grid item md={3}>
                                <Autocomplete
                                    id="deviceid"
                                    name="deviceid"
                                    options={
                                        devices
                                    }
                                    size="small"
                                    value={fieldValueDevice}
                                    getOptionLabel={(option) => option.vehicle_id}
                                    isOptionEqualToValue={(option, value) => option.device === value.device}
                                    fullWidth
                                    renderOption={(props, item) => (
                                        <li {...props} key={item.key}>
                                            <ListItemText>{item.vehicle_id}</ListItemText>
                                        </li>
                                    )}
                                    filterOptions={(options, state) => {
                                        return options.filter(opt => opt.vehicle_id.toUpperCase().includes(state.inputValue.toUpperCase()))
                                    }}
                                    onChange={(e, value) => {
                                        setFieldValueDevice(value);
                                        setIsSubmit(false)
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            label="เลือกอุปกรณ์ GPS"
                                            fullWidth
                                            autoComplete="off"
                                            name="deviceid"
                                            {...params}
                                        />
                                    )}
                                />
                            </Grid>
                            {
                                fieldDynamicValue && (
                                    <Grid item md={2}>
                                        {
                                            fieldDynamicValue?.id === "dynamic_speed" && (
                                                <TextField
                                                    required
                                                    label="speed"
                                                    type={fieldDynamicValue?.type === "int" ? "number" : "text"}
                                                    inputProps={{ min: fieldDynamicValue?.min, max: fieldDynamicValue?.max }}
                                                    fullWidth
                                                    autoComplete="off"
                                                    name="dynamic_speed"
                                                    size="small"
                                                    value={fieldDynamicSpeed}
                                                    onChange={(e) => {
                                                        setfieldDynamicSpeed(e.target.value)
                                                        setIsSubmit(false)
                                                    }}
                                                />
                                            )
                                        }
                                    </Grid>
                                )
                            }
                            <Grid item md={fieldDynamicValue ? 2 : 3}>
                                <TextField
                                    value={fieldValueStart}
                                    onChange={(val) => {
                                        const { value } = val.target
                                        setFieldValueStart(`${fDateTo(value, "yyyy-MM-dd HH:mm")}`);
                                        setFieldValueEnd(`${fDateTo(new Date(value).setHours(23, 59, 59), "yyyy-MM-dd HH:mm")}`);
                                        setIsSubmit(false)

                                    }}
                                    type="datetime-local"
                                    size="small"
                                    fullWidth
                                    placeholder="YYYY/MM/DD"
                                    autoComplete="off"
                                    label="วันเวลาเริ่ม"
                                    inputProps={{
                                        // readOnly: true,
                                        ampm: false,
                                        max: fDateTo(new Date().setHours(23, 59, 59), "yyyy-MM-dd HH:mm"),
                                    }}
                                />
                            </Grid>
                            <Grid item md={fieldDynamicValue ? 2 : 3}>
                                <TextField
                                    value={fieldValueEnd}
                                    onChange={(val) => {
                                        const { value } = val.target
                                        setFieldValueEnd(`${fDateTo(value, "yyyy-MM-dd HH:mm")}`);
                                        setIsSubmit(false)
                                    }}
                                    type="datetime-local"
                                    size="small"
                                    fullWidth
                                    placeholder="YYYY/MM/DD"
                                    autoComplete="off"
                                    label="ถึงวันเวลา"
                                    readOnly={true}
                                    inputProps={{
                                        // readOnly: true,
                                        ampm: false,
                                        min: fDateTo(new Date(fieldValueStart), "yyyy-MM-dd HH:mm"),
                                        max: fDateTo(new Date(new Date(fieldValueStart).setDate(new Date(fieldValueStart).getDate() + 2)).setHours(23, 59, 59), "yyyy-MM-dd HH:mm"),
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "center", justifyItems: "center", marginTop: "10px" }}>
                        <Button disabled={fieldValueDevice === null || type.url === ""} variant="contained" type="submit">ค้นหา</Button>
                    </Box>
                </form>
            </LocalizationProvider>
            {
                isSubmit && (
                    <div style={{ marginTop: "10px", height: "calc(100vh - 120px)", overflow: "hidden" }}>
                        <Iframe
                            key={key}
                            oUrl={type.url}
                            device={fieldValueDevice?.device}
                            cname={fieldValueDevice?.cname}
                            gpsModel={fieldValueDevice?.gpsmodel}
                            speed={fieldDynamicSpeed}
                            date_s={fDateTo(`${fieldValueStart}:00`, 'yyyy-MM-dd HH:mm:ss')}
                            date_e={fDateTo(`${fieldValueEnd}:59`, 'yyyy-MM-dd HH:mm:ss')}
                            fuel_volte={fieldValueDevice?.fuel_volte}
                            fuel_liter={fieldValueDevice?.fuel_liter}
                            fuel_volte_reverse={fieldValueDevice?.fuel_volte_reverse}
                        />
                    </div>
                )
            }
        </div>
    )
}


const Iframe = ({ oUrl, device, gpsModel, date_s, date_e, cname, speed, fuel_volte, fuel_liter, fuel_volte_reverse, key }) => {
    const [iframeUrl, setIframeUrl] = useState('');

    useEffect(() => {
        if (oUrl) {
            const originalUrl = oUrl;
            const url = new URL(originalUrl);
            const params = new URLSearchParams(url.search);
            // แก้ไขค่าที่ต้องการ
            params.set('var-device', device);
            params.set('var-gpsmodel', gpsModel);
            params.set('var-cname', cname);
            params.set('from', date_s);
            params.set('to', date_e);
            params.set('theme', 'light');


            if (params.has("var-fuel_volte")) {
                params.set('var-fuel_volte', fuel_volte);
            }
            if (params.has("var-fuel_liter")) {
                params.set('var-fuel_liter', fuel_liter);
            }
            if (params.has("var-fuel_volte_reverse")) {
                params.set('var-fuel_volte_reverse', fuel_volte_reverse);
            }
            if (params.has("var-dynamic_speed")) {
                params.set('var-dynamic_speed', speed);
            }
            // ประกอบกลับ
            url.search = params.toString();
            setIframeUrl(url.toString());
        }
    }, [device, gpsModel, date_s, date_e, cname, speed]);

    // console.log('iframeUrl', iframeUrl)

    return (
        <div style={{ width: "100%", height: "100%" }}>
            {iframeUrl && (
                <iframe
                    key={key}
                    style={{ width: "100%", height: "100%" }}
                    src={iframeUrl}
                />
            )}
        </div>
    )
}
